import { AppView, UserRole } from "../types";

export interface RoleConfig {
  role: UserRole;
  defaultView: AppView;
  allowedViews: AppView[];
}

export const ROLE_CONFIGS: Record<UserRole, RoleConfig> = {
  admin: {
    role: "admin",
    defaultView: "overview",
    allowedViews: ["overview", "data-health", "ingest", "users", "clinical", "doctor-dash", "patient-intel", "nurse-dash", "lab-dash", "desk-dash", "dept-dash", "mgmt-dash", "billing", "payment-dash", "alerts-dash"],
  },
  ops_lead: {
    role: "ops_lead",
    defaultView: "overview",
    allowedViews: ["overview", "data-health", "ingest", "clinical", "billing", "desk-dash", "payment-dash", "alerts-dash"],
  },
  doctor: {
    role: "doctor",
    defaultView: "doctor-dash",
    allowedViews: ["doctor-dash", "patient-intel", "clinical", "billing", "alerts-dash", "payment-dash"],
  },
  nurse: {
    role: "nurse",
    defaultView: "nurse-dash",
    allowedViews: ["nurse-dash", "billing", "alerts-dash", "payment-dash"],
  },
  lab_staff: {
    role: "lab_staff",
    defaultView: "lab-dash",
    allowedViews: ["lab-dash", "billing", "payment-dash"],
  },
  desk_staff: {
    role: "desk_staff",
    defaultView: "desk-dash",
    allowedViews: ["desk-dash", "billing", "payment-dash"],
  },
  dept_head: {
    role: "dept_head",
    defaultView: "dept-dash",
    allowedViews: ["dept-dash", "data-health", "billing", "alerts-dash", "payment-dash"],
  },
  management: {
    role: "management",
    defaultView: "mgmt-dash",
    allowedViews: ["mgmt-dash", "billing", "payment-dash"],
  },
};

// Hardcoded mock email-to-role mapping for Hackathon
export const MOCK_USER_ROLES: Record<string, UserRole> = {
  "admin@hospops.com": "admin",
  "ops@hospops.com": "ops_lead",
  "doctor@hospops.com": "doctor",
  "nurse@hospops.com": "nurse",
  "lab@hospops.com": "lab_staff",
  "desk@hospops.com": "desk_staff",
  "head@hospops.com": "dept_head",
  "mgmt@hospops.com": "management",
};

export function getRoleForEmail(email: string | null | undefined): UserRole {
  if (!email) return "ops_lead"; // Fallback to Ops Lead for generic demo mode
  const role = MOCK_USER_ROLES[email.toLowerCase()];
  return role || "ops_lead"; // Fallback
}
